import React from 'react';
import { UserPlus, Plus } from 'lucide-react';

/**
 * AddTeamMemberCard — create-team-member form. Bypasses the invite-code
 * flow for founders/staff. Stateless; parent supplies form state +
 * handler. Extracted from Admin.jsx.
 */
const AddTeamMemberCard = ({
  tmEmail, setTmEmail,
  tmName, setTmName,
  tmPassword, setTmPassword,
  tmRole, setTmRole,
  tmCohort, setTmCohort,
  tmBusy,
  tmSuccess,
  onCreate,
}) => (
  <div className="bg-enf-surface-deep border border-enf-surface-border rounded-xl p-6 mb-10">
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-2">
        <UserPlus className="w-4 h-4 text-enf-accent-fg" />
        <div className="text-sm font-semibold uppercase tracking-widest text-enf-text-secondary">Add team member</div>
      </div>
      <span className="text-xs text-enf-text-muted">Bypasses invite code · for founders & staff</span>
    </div>

    {tmSuccess && (
      <div className="mb-4 px-4 py-3 enf-success-banner bg-emerald-900/20 border border-emerald-700/40 rounded-md text-sm text-emerald-300" data-testid="team-create-success">
        {tmSuccess}
      </div>
    )}

    <form onSubmit={onCreate} className="grid md:grid-cols-2 lg:grid-cols-5 gap-2" data-testid="team-create-form">
      <input
        type="email" placeholder="email@example.com" value={tmEmail}
        onChange={(e) => setTmEmail(e.target.value)} required
        className="px-3 py-2 bg-enf-surface-mid border border-enf-surface-border rounded-md text-enf-text-primary text-sm focus:outline-none focus:border-enf-accent-fg"
        data-testid="team-new-email"
      />
      <input
        type="text" placeholder="Display name" value={tmName}
        onChange={(e) => setTmName(e.target.value)}
        className="px-3 py-2 bg-enf-surface-mid border border-enf-surface-border rounded-md text-enf-text-primary text-sm focus:outline-none focus:border-enf-accent-fg"
        data-testid="team-new-name"
      />
      <input
        type="text" placeholder="Temp password (8+ chars)" value={tmPassword}
        onChange={(e) => setTmPassword(e.target.value)} required minLength={8}
        className="px-3 py-2 bg-enf-surface-mid border border-enf-surface-border rounded-md text-enf-text-primary text-sm font-mono focus:outline-none focus:border-enf-accent-fg"
        data-testid="team-new-password"
      />
      <select
        value={tmRole} onChange={(e) => setTmRole(e.target.value)}
        className="px-3 py-2 bg-enf-surface-mid border border-enf-surface-border rounded-md text-enf-text-primary text-sm focus:outline-none focus:border-enf-accent-fg"
        data-testid="team-new-role"
      >
        <option value="admin">Admin</option>
        <option value="user">User</option>
      </select>
      <div className="flex gap-2">
        <input
          type="text" placeholder="Cohort" value={tmCohort}
          onChange={(e) => setTmCohort(e.target.value)}
          className="flex-1 min-w-0 px-3 py-2 bg-enf-surface-mid border border-enf-surface-border rounded-md text-enf-text-primary text-sm focus:outline-none focus:border-enf-accent-fg"
          data-testid="team-new-cohort"
        />
        <button type="submit" disabled={tmBusy}
          className="px-3 py-2 bg-enf-accent hover:bg-enf-accent-hover disabled:bg-enf-surface-elevated disabled:text-enf-text-muted rounded-md text-sm font-semibold flex items-center gap-1.5 transition-colors flex-shrink-0"
          data-testid="team-create-submit"
        >
          <Plus className="w-4 h-4" /> {tmBusy ? '...' : 'Add'}
        </button>
      </div>
    </form>
    <div className="text-xs text-enf-text-muted mt-3">
      Tip: Share the temp password with the new user. They can change it via Profile → Account once signed in.
    </div>
  </div>
);

export default AddTeamMemberCard;
